import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApplyRoutingModule } from './apply-routing.module';
import { ApplyComponent } from './apply.component';
import { GlobalUIComponentsModule } from '../../ui-components/global/global-ui-components.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

@NgModule({
    declarations: [ApplyComponent],
    imports: [
        CommonModule,
        ApplyRoutingModule,
        GlobalUIComponentsModule,
        MatIconModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        MatSnackBarModule
    ],
})
export class ApplyModule { }
